























































































import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {譲渡譲受医療機関型, 削除フラグ型, 譲渡譲受医療機関初期値} from '@/type/transfermedical/transferMedical';
import {progress} from '@/script/progress';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {loginModule} from '@/store/authentication/login';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';

@Component({
  components: {
    ConfirmDialog,
    NormalButton,
    NormalDialog,
    AlertDialog,
  },
})

export default class UpdateTransferMedical extends Vue {

  private アラートメッセージ: string[] = [];

  @Prop({default: false})
  private modal!: boolean;

  @Prop({default: 譲渡譲受医療機関初期値})
  private transferMedical!: 譲渡譲受医療機関型;

  private 更新後医療機関: 譲渡譲受医療機関型 = {...this.transferMedical};

  @Watch('modal')
  private changeDialog(nowModal: boolean, prevModal: boolean) {
    if (nowModal) {
      this.更新後医療機関 = {...this.transferMedical};
      this.openDialog('譲渡譲受医療機関マスタ更新画面');
    }
  }

  @Emit('close-form')
  private closeForm() {
    this.clear();
    this.closeDialog('譲渡譲受医療機関マスタ更新画面');
  }

  private created(): void {
    if (this.更新後医療機関 === null) {
      this.更新後医療機関 = {...譲渡譲受医療機関初期値};
    }
  }

  private openDialog(name: string): void {
    this.$modal.show(name);
  }

  private closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  private updateHandler() {
    progress(this.update);
  }

  private async update(): Promise<void> {
    if (this.更新後医療機関 !== null) {
      await api.譲渡譲受医療機関を更新する(this.更新後医療機関)
        .then(
          () => {
            this.closeDialog('確定ダイアログ');
            this.closeForm();
          },
          (error: any) => {
            this.closeDialog('確定ダイアログ');
            this.アラートメッセージ = error.data.errors;
            this.openDialog('譲渡譲受入力アラートダイアログ');
          },
        );
    }
  }

  private clear() {
    this.init();
    this.closeDialog('クリアダイアログ');
  }

  private init() {
    this.更新後医療機関 = {...this.transferMedical};
  }

  private 削除済みである(): boolean {
    if (this.transferMedical === null) {
      return false;
    }
    return this.transferMedical.削除フラグ === 削除フラグ型.削除;
  }
}
